import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { transformExtent, fromLonLat, transform, toLonLat } from "ol/proj";
import { toLine, getImg, formatRGBA, getformatstruct, getformitemsdata, getformListItemsdatas, bd_decrypt, formateDate, _isMobile } from "@/utils/utils";
import { mapState, mapGetters, mapMutations } from "vuex";
import mapv2assembly from "@/view/map/customv2/hebeiMap";
import mappopupv3 from "@/view/map/customv2/comp1PopUpHubei";
import typev3 from "@/view/map/customv2/comp1Hebei";
import pointlistv2 from "@/components/mapv2/listv2/index";
import axios from "axios";
import { BMapLoader } from "@/utils/bdMap.js";
import cdata from "@/view/map/hdmconfigv2/common.js";
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import routelistv2 from "@/view/map/customv2/routelistHebei";
export default {
  name: "hebeidaxue",
  components: {
    mapv2assembly,
    mappopupv3,
    typev3,
    pointlistv2,
    routelistv2
  },
  props: {
    // 0配置页 1展示页
    id: {
      type: Number,
      default: 1
    },
    mapform: {
      type: Object,
      default: {}
    },
    style: {
      type: Object,
      default: {}
    },
    typelist: {
      type: Array,
      default: []
    },
    isloadingmap: {
      type: Boolean,
      default: false
    },
    maplayer: {
      type: Object,
      default: {}
    },
    viewInfo: {
      type: Object,
      default: {}
    },
    streetcode: {
      type: Array,
      default: []
    },
    mappointList: {
      type: Array,
      default: []
    },
    culturalList: {
      type: Array,
      default: []
    },
    maptemplate: {
      type: Number,
      default: 0
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    routelist: {
      type: Array,
      default: []
    },
    rtypelist: {
      type: Array,
      default: []
    },
    senior: {
      type: Object,
      default: {}
    },
    editorlist: {
      type: Array,
      default: []
    },
    domeditorflag: {
      type: Boolean,
      default: false
    },
    editordata: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      isMobileflag: false,
      // 移动端判断
      query: "",
      formUserId: "",
      // 最外层样式
      mainStyle: {
        width: "",
        height: "",
        transform: "scale(1)",
        transformOrigin: "0 0",
        position: "relative"
      },
      // 除地图以外的数据集合
      mapelem: {
        bg: "",
        logo: "",
        pickey: "",
        golist: "https://p.ananas.chaoxing.com/star3/origin/3df243657b8ae7d4bd4eccd3446f3639.png",
        bgaudio: ""
      },
      // 除地图以外的样式集合
      modulestyle: {
        logo: "",
        pickey: "",
        type: "",
        list: "",
        visit: "",
        bgaudio: ""
      },
      cTemplateScore: 0,
      popmodeltype: 0,
      // 弹窗默认模板样式
      pointdetail: {},
      popshowflag: false,
      showtype: 1,
      modeltype: 0,
      showlistflag: 1,
      typebtn: [],
      showgolist: false,
      showgolistId: 0,
      cform: {},
      // 非遗项目表单数据
      cformlabel: {},
      // 非遗项目表单结构标题集合
      cformoption: {},
      // 非遗项目表单结构默认选择项值集合
      cformfield: {},
      // 非遗项目表单校验集合
      cstructList: [],
      // 非遗项目表单结构数据
      cpList: [],
      // 添加或编辑非遗项目表单数据时列表
      defaultcform: {},
      // 非遗项目默认form数据
      cformUser: {},
      // 地图配置当前行ID数据
      formatData: {},
      // 地图配置当前行ID 格式化数据
      sList: [],
      // 添加或编辑地图表单数据时列表
      form: {},
      // 地图表单数据
      formlabel: {},
      // 地图表单结构标题集合
      formoption: {},
      // 地图表单结构默认选择项值集合
      formfield: {},
      // 地图表单校验集合
      mapview: {},
      loadingmap: false,
      mapLayers: {},
      mapstyle: {},
      jsonOption: {},
      typeList: [],
      // 分类列表数据
      mapstreetcode: [],
      typeform: {
        formId: "260297",
        page: 1,
        limit: 100,
        searchStr: ""
      },
      // 分类列表查询字段
      pointform: {
        formId: "165054",
        page: 1,
        limit: 100,
        searchStr: ""
      },
      // 点位查询字段集合
      // 搜索定位点字段
      searchStr: {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "40",
            compt: "editinput",
            express: "===",
            val: ""
          }]
        }, {
          model: 1,
          filters: []
        }]
      },
      coordinate: "",
      // 当前点击经纬度
      defaultpointList: [],
      // 点位列表数据
      pointList: [],
      // 点位列表数据
      mapdefaultculturalList: [],
      // 非遗项目列表数据
      mapculturalList: [],
      // 非遗项目列表数据
      culturalform: {
        formId: "cultural_heritage_project",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c"
      },
      // 非遗项目表单字段
      mapculturalpersonList: [],
      // 非遗人列表数据 culturalHeritageInheritor202405192327
      culturalpersonform: {
        formId: "cultural_heritage_inheritor",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba"
      },
      // 非遗人表单字段
      mapculturalpicList: [],
      // 项目图片列表数据 culturalpic2024052571429
      culturalpicform: {
        formId: "21416",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "0bef8d07ada7bc791d6ebf0bcc4c8a8a"
      },
      // 项目图片表单字段
      mapculturalvideoList: [],
      // 项目视频列表数据 culturalvideo202405281701
      culturalvideoform: {
        formId: "12479",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "ebc411877446a47bd84c8cb30c90410b"
      },
      // 项目视频表单字段
      maprouteList: [],
      // 路线列表数据
      mapcontainer: "",
      routeform: {
        formId: "1626576",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "8cb8793ff32dba9935520c2f7473a33e83825a93035ae6268d91df56c28f60d9",
        orderType: "asc"
      },
      // 路线查询字段集合
      routePop: false,
      bdmaploaction: {},
      rtypeform: {
        formId: "1626580",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "7e324a759ba7eeb834922850eb694d88cedc5ae94849013a92bd11cd2b9784dd"
      },
      // 路线分类列表查询字段
      rtypeList: [],
      // 路线分类列表数据
      mapTimer: null,
      routeAllSource: [],
      routeAllLen: 0,
      routePoint: [],
      cType: "",
      routejson: {},
      visitform: {
        formId: "map_visits",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "146f7409beffcce7387a55a86b9f3908f7823c3fe5626184c9149f3cb3a5eefe"
      },
      // 浏览量查询字段
      visitItem: [{
        num: 0
      }],
      mapsenior: {},
      bgaudio: "",
      bgaudioflag: true,
      editorList: [],
      cloudClickCount: 1
    };
  },
  computed: {
    ...mapGetters(["mapv2info"])
  },
  watch: {
    mapform: {
      handler(val) {
        if (val) {
          this.form = val;
          this.mapformHandle(val);
        }
      },
      deep: true
    },
    style: {
      handler(val) {
        if (val) {
          // console.log(`supermapstyle`, val);
          this.mapstyle = val;
          this.styleHandle(val);
        }
      },
      deep: true
    },
    "style.typebtn": {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    "style.popcolor"(val) {
      if (val) this.popcolorFormat(val);
    },
    "style.typeall": {
      handler(val) {
        // console.log(`style.typeall`, val)
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    "style.typeallname": {
      handler(val) {
        // console.log(`style.typeallname`, val)
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    viewInfo: {
      handler(val) {
        this.mapview = val;
      },
      deep: true
    },
    isloadingmap(val) {
      this.loadingmap = val;
    },
    maplayer: {
      handler(val) {
        this.mapLayers = val;
      },
      deep: true
    },
    typelist: {
      handler(val) {
        this.typeList = val;
      },
      deep: true
    },
    mappointList: {
      handler(val) {
        // console.log(`mappointList`, val);
        this.pointList = val;
      },
      deep: true
    },
    culturalList: {
      handler(val) {
        this.mapculturalList = val;
      },
      deep: true
    },
    maptemplate(val) {
      this.cTemplateScore = val;
    },
    streetcode(val) {
      this.mapstreetcode = val;
    },
    isMobile(val) {
      this.isMobileflag = val;
      this.changeMobile(val);
    },
    routelist: {
      handler(val) {
        this.maprouteList = val;
        this.routeHandle(this.maprouteList);
      },
      deep: true
    },
    rtypelist: {
      handler(val) {
        this.rtypeList = val;
      },
      deep: true
    },
    senior: {
      handler(val) {
        if (val) {
          console.log(`supermapsenior`, val);
          this.mapsenior = val;
        }
      },
      deep: true
    },
    editorlist: {
      handler(val) {
        if (val) {
          console.log(`editorlist`, val);
          this.editorList = val;
        }
      },
      deep: true
    },
    "mapv2info.style.typebtn": {
      handler(val) {
        if (val) this.typebtnFormat(val);
      },
      deep: true
    },
    "mapv2info.style": {
      handler(val) {
        // console.log(`this.mapv2info.style`, this.mapv2info.style)
        if (val) this.styleHandle(val);
      },
      deep: true
    },
    "mapv2info.style.popcolor"(val) {
      if (val) this.popcolorFormat(val);
    },
    "mapv2info.style.typeall": {
      handler(val) {
        this.mapstyle.typeall = val;
      },
      deep: true
    },
    "mapv2info.style.typeallname": {
      handler(val) {
        this.mapstyle.typeallname = val;
      },
      deep: true
    },
    "mapv2info.style.routebutton": {
      handler(val) {
        this.mapstyle.routebutton = val;
      },
      deep: true
    },
    "mapv2info.style.routebuttontext": {
      handler(val) {
        this.mapstyle.routebuttontext = val;
      },
      deep: true
    },
    "mapv2info.style.routepos": {
      handler(val) {
        this.mapstyle.routepos = val;
      },
      deep: true
    },
    "mapv2info.style.routebtn": {
      handler(val) {
        this.mapstyle.routebtn = val;
      },
      deep: true
    },
    "mapv2info.style.listStyleIndex": {
      handler(val) {
        // console.log(`mapv2info.style.listStyleIndex`, val);
        if (val) this.mapstyle.listStyleIndex = val;
      },
      deep: true
    },
    "mapv2info.senior.visit": {
      handler(val) {
        // console.log(`mapv2info.senior.visit`, val);
        this.mapsenior.visit = val;
      },
      deep: true
    },
    "mapv2info.senior.visitname": {
      handler(val) {
        // console.log(`mapv2info.senior.visitname`, val);
        this.mapsenior.visitname = val;
      },
      deep: true
    },
    "mapv2info.senior.effect": {
      handler(val) {
        // console.log(`mapv2info.senior.effect`, val);
        this.mapsenior.effect = val;
        if (val) this.effectAnimate(val);
      },
      deep: true
    }
  },
  beforeMount() {
    // this.$router.replace({
    //   path: "/hebeidaxuemap", // 新路径
    //   query: this.$route.query, // 保留原有查询参数
    // });
    const url = "https://museum.chaoxing.com/micro-frontend/school/#/hebeidaxuemap";
    const params = new URLSearchParams({
      fid: this.$route.query.fid,
      uid: this.$route.query.uid,
      formUserId: this.$route.query.formUserId
    });
    window.location.replace(`${url}?${params.toString()}`);
    return;
  },
  created() {
    this.mapconStyle();
    this.$options.initialState = JSON.parse(JSON.stringify(this.$data));
  },
  mounted() {
    this.query = this.$route.query;
    this.formUserId = this.query.formUserId;
    // 展示页请求相关接口数据
    if (this.id === 1) {
      this.setComonStyle();
      this.getMapData();
    }
    // this.getStudentWorks();
    // this.getGoodCases()
    // setTimeout(() => {
    //   this.loadingmap = false;
    // }, 5000);
    // setTimeout(() => {
    //   // this.query = this.$route.query;
    //   // this.formUserId = this.query.formUserId;
    //   // this.setComonStyle();
    //   // this.resetAllData();
    //   // this.$forceUpdate();
    //   this.getMapData("保定市");
    //   // this.$nextTick(() => {
    //   //   this.loadBmap();
    //   // });
    // }, 8000);
    this.$nextTick(() => {
      this.loadBmap();
      // this.rotateCloud();
    });
  },
  methods: {
    ...mapMutations(["SET_MAPSENIOR", "SET_MAPVIEW", "SET_MAPFORM", "SET_MAPFORMITEM", "SET_MAPSTYLEITEM", "SET_MAPDRAWLAYER", "SET_COORDINATE", "SET_MAPROUTESOURCE"]),
    getStudentWorks(location = "", page = 1) {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "xsyxzp",
        page: page,
        limit: 8,
        t: "ea0071355007a143190fbaf5b26554fbaa5084d3028db91d73d6a5f2391a6610"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "yxzp_location",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        console.log("singleadvanceSearch", res);
      });
    },
    getGoodCases(location = "", page = 1) {
      let forms = {
        deptId: this.$route.query.fid,
        formId: "szysal",
        page: page,
        limit: 8,
        t: "ee27e1aa35c220778f923820b83841e7aa5084d3028db91d73d6a5f2391a6610"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "ysal_place",
            compt: "selectbox",
            express: "===",
            val: [location]
          }]
        }]
      };
      if (location) {
        forms.searchStr = encodeURI(JSON.stringify(searchStr));
      }
      this.$api.singleadvanceSearchv2(forms).then(res => {
        console.log("getGoodCases", res);
      });
    },
    rotateCloud() {
      this.cloudClickCount++;
      // 获取三个标签元素
      const cloud1 = document.querySelector(".cloud_1");
      const cloud2 = document.querySelector(".cloud_2");
      const cloud3 = document.querySelector(".cloud_3");

      // 如果元素不存在，直接返回
      if (!cloud1 || !cloud2 || !cloud3) return;

      // 获取当前元素的计算样式
      const style1 = window.getComputedStyle(cloud1);
      const style2 = window.getComputedStyle(cloud2);
      const style3 = window.getComputedStyle(cloud3);

      // 解析当前位置（处理left/right和top/bottom）
      const pos1 = this.getPosition(style1);
      const pos2 = this.getPosition(style2);
      const pos3 = this.getPosition(style3);

      // 保存当前位置
      const currentPositions = [pos1, pos2, pos3];

      // 计算弧线移动的目标位置（使用贝塞尔曲线）
      const targetPositions = this.calculateArcPositions(currentPositions);

      // 应用新位置并添加动画
      this.animateToPosition(cloud1, targetPositions[0]);
      this.animateToPosition(cloud2, targetPositions[1]);
      this.animateToPosition(cloud3, targetPositions[2]);
      if (this.cloudClickCount % 3 == 0) {
        cloud2.style.left = "20%";
      }
    },
    // 获取元素位置（处理left/right和top/bottom）
    getPosition(style) {
      let left, top;
      if (style.left && style.left !== "auto") {
        left = parseFloat(style.left);
      } else if (style.right && style.right !== "auto") {
        left = window.innerWidth - parseFloat(style.right) - parseFloat(style.width);
      }
      if (style.top && style.top !== "auto") {
        top = parseFloat(style.top);
      } else if (style.bottom && style.bottom !== "auto") {
        top = window.innerHeight - parseFloat(style.bottom) - parseFloat(style.height);
      }
      return {
        left,
        top,
        width: parseFloat(style.width),
        height: parseFloat(style.height)
      };
    },
    // 计算弧线移动的目标位置
    calculateArcPositions(positions) {
      // 位置交换顺序: 1->2, 2->3, 3->1
      const targetIndices = [1, 2, 0];
      const targetPositions = [];
      positions.forEach((pos, index) => {
        const targetIndex = targetIndices[index];
        const targetPos = positions[targetIndex];

        // 计算弧线的控制点（中点上方20%）
        const controlX = (pos.left + targetPos.left) / 2;
        const controlY = (pos.top + targetPos.top) / 2 - Math.abs(pos.top - targetPos.top) * 0.2;

        // 保存目标位置和控制点
        targetPositions.push({
          target: targetPos,
          control: {
            x: controlX,
            y: controlY
          }
        });
      });
      return targetPositions;
    },
    // 元素动画到目标位置
    animateToPosition(element, target) {
      const {
        target: targetValue,
        control
      } = target;
      const duration = 800; // 动画持续时间（毫秒）

      // 清除原有样式
      element.style.transition = "";
      element.style.left = "";
      element.style.right = "";
      element.style.top = "";
      element.style.bottom = "";

      // 设置动画样式
      element.style.transition = `left ${duration}ms`, element.style.transition += `, top ${duration}ms`;

      // 计算并设置目标位置
      if (targetValue.left !== undefined) {
        element.style.left = `${targetValue.left}px`;
      } else {
        element.style.right = `${window.innerWidth - targetValue.left - targetValue.width}px`;
      }
      if (targetValue.top !== undefined) {
        element.style.top = `${targetValue.top}px`;
      } else {
        element.style.bottom = `${window.innerHeight - targetValue.top - targetValue.height}px`;
      }
    },
    loadBmap() {
      BMapLoader().then(BMap => {
        this.mapTimer = setInterval(() => {
          if (window.BMapGL && window.BMapGL.Map && window.BMapGL.Point) {
            this.mapcontainer = new BMap.Map("bdmap");
            let geolocation = new BMap.Geolocation();
            geolocation.getCurrentPosition(a => {
              console.log(a);
              this.bdmaploaction.address = a.address;
              this.bdmaploaction.lng = a.point.lng;
              this.bdmaploaction.lat = a.point.lat;
              localStorage.setItem("bdlocation", JSON.stringify(this.bdmaploaction));
            });
            clearInterval(this.mapTimer);
            this.mapTimer = null;
          }
        }, 100);
      });
    },
    mapconStyle() {
      this.mainStyle.width = `${window.innerWidth}px`;
      this.mainStyle.height = `${window.innerHeight}px`;
      if (_isMobile()) this.isMobileflag = true;
    },
    percentageChange(scale) {
      this.mainStyle.transform = `scale(${scale})`;
    },
    /**
     * 定位点格式化
     */
    posFormat(val) {
      delete val.ptype;
      delete val.pIndex;
      return val;
    },
    popcolorFormat(val) {
      let obj = formatRGBA(val);
      let theme1 = `rgba(${obj.r},${obj.g},${obj.b},1)`;
      let theme2 = `rgba(${obj.r},${obj.g},${obj.b},0.7)`;
      document.documentElement.style.setProperty("--hand-drawn-pop-colortheme1", theme1);
      document.documentElement.style.setProperty("--hand-drawn-pop-colortheme07", theme2);
    },
    styleHandle(val) {
      // console.log(`styleHandle`, val)
      this.popmodeltype = val.popStyleIndex === undefined ? this.form.cTemplateScore === 1 ? 1 : 0 : val.popStyleIndex;
      this.modeltype = val.typeStyleIndex === undefined ? 0 : val.typeStyleIndex;
      Object.keys(this.modulestyle).forEach(key => {
        let pos = this.posFormat(val[`${key}pos`] !== undefined ? {
          ...val[`${key}pos`]
        } : {
          ...this.mapv2info.style[`${key}pos`]
        });
        let appPos = {};
        Object.keys(pos).forEach(item => {
          appPos[item] = this.isMobileflag ? `${parseFloat((parseInt(pos[item]) / 2 / 37.5).toFixed(6))}rem` : `${parseFloat((parseInt(pos[item]) / 1920 * 100).toFixed(6))}vw`;
        });
        this.modulestyle[key] = appPos;
      });
      if (val.typedisplay) this.modulestyle.type = Object.assign({}, this.modulestyle.type, val.typedisplay);
      if (val.visitdom !== undefined) this.modulestyle.visit = Object.assign({}, this.modulestyle.visit, val.visitdom[0]);
      // console.log(`this.modulestyle`, this.modulestyle)
    },
    mapformHandle(val) {
      console.log(`mapformHandle`, val);
      if (!this.isMobileflag) {
        this.mapelem.bg = val.background_img && val.background_img.length > 0 ? getImg(val.background_img[0]) : "";
      }
      if (this.isMobileflag) {
        this.mapelem.bg = val.app_bg_img && val.app_bg_img.length > 0 ? getImg(val.app_bg_img[0]) : "";
      }
      this.mapelem.logo = val.logo && val.logo.length > 0 ? getImg(val.logo[0]) : "";
      this.mapelem.pickey = val.pickey && val.pickey.length > 0 ? getImg(val.pickey[0]) : "";
      if (val.bgaudioicon && val.bgaudioicon[0]) this.mapelem.bgaudio = getImg(val.bgaudioicon[0]);
      this.showtype = val.showtype;
      this.showlistflag = val.showlistflag;
      if (val.customvisits !== undefined && val.visits !== undefined) this.visitItem[0].num = Number(val.customvisits) + Number(val.visits);
      /* centerflag 配置页调整地图center时 不触发不请求接口 */
      if (!val.centerflag) this.isHasallarea(val);
      if (val.cTemplateScore === 1) this.getCulturalFormStruct();
      /* 若包含背景音乐 */
      if (val.bgaudiofile && val.bgaudiofile[0]) this.getBgaudiofile(val.bgaudiofile[0]);
      if (val.editorList && val.editorList.length > 0) this.editorList = val.editorList;
    },
    changeMobile(val) {
      this.mapformHandle(this.form);
      if (val) {
        this.mainStyle.width = "375px";
        this.mainStyle.height = "667px";
      } else {
        this.mainStyle.width = `${window.innerWidth}px`;
        this.mainStyle.height = `${window.innerHeight}px`;
      }
    },
    markermoveend(val) {
      if (this.id === 1) {
        // 点击单个路线时 禁止缩放更新数据
        if (this.routePoint.length > 0) return;
        // 非遗模版 地点数据 无层级字段 禁止缩放获取层级数据
        if (this.form.cTemplateScore === 1) {
          this.culturalform.page = 1;
          this.getIntangibleCulturalHeritageData();
          if (this.isMobileflag) this.removeDrawsource();
          return;
        }
        this.popshowflag = false;
        this.removeAlliconsource();
        let zoom = val;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          console.log(`Difference`, Difference);
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            alias: "map_level",
            compt: "editinput",
            express: "===",
            val: i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        this.pointform.page = 1;
        this.pointList = [];
        console.log(1);
        this.getpointData();
      } else {
        this.$emit("markermoveend", val);
      }
    },
    singleclick(val) {
      this.SET_COORDINATE(val);
    },
    /**
     * 定位点击操作
     * @param {Object} feature 选中数据
     */
    markerclick(feature) {
      this.pointdetail = {};
      this.popshowflag = false;
      if (!this.isMobileflag) document.querySelector(".map_content").style.zIndex = 2;
      if (feature === undefined) return;
      if (!this.isMobileflag) document.querySelector(".map_content").style.zIndex = 5;
      // 判断feature类型
      let gtype = feature.getGeometry().getType();
      // point显示弹窗详情
      if (gtype === "Point") {
        let id = feature.get("id");
        let score = feature.get("score");
        let currentInfo = "";
        if (this.pointList.length > 0) currentInfo = this.pointList.find(item => {
          return item.id === id;
        });
        if (this.mapculturalList.length > 0) currentInfo = this.mapculturalList.find(item => {
          return item.id === id;
        });
        if (currentInfo === undefined) return;
        // 标准模版获取弹窗
        if (score === 0) this.standardDetail(currentInfo);
        // 非遗模版获取弹窗
        if (score === 1) this.culturalDetail(currentInfo, feature);
      }
      // 总地图点击进入分地图
      if (gtype === "Polygon" && this.form.ishaschild === "是" && this.id === 1) {
        let code = feature.get("code");
        let that = this;
        let mapform = {
          deptId: this.query.fid,
          formId: "177623",
          page: 1,
          limit: 100,
          searchStr: {
            model: 0,
            filters: [{
              model: 0,
              filters: [{
                alias: "50",
                compt: "editinput",
                express: "like",
                val: code
              }]
            }]
          }
        };
        mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
        this.$api.singleadvanceSearch(mapform).then(res => {
          if (res.totalRow > 0) {
            let cquery = location.hash.split("?")[1];
            let cparams = cquery.split("&");
            cparams = cparams.map(item => {
              let itemarr = item.split("=");
              if (itemarr[0] === "formUserId") {
                itemarr[1] = res.dataList[0].id;
                item = itemarr.join("=");
              }
              return item;
            });
            window.location.href = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams.join("&");
          }
        });
      }
      // LineString路线点击显示详情
      if (gtype === "LineString" && feature.get("type") === "allroute") {
        let id = feature.get("id");
        let routeItem = this.maprouteList.find(item => {
          return item.id === id;
        });
        if (routeItem !== undefined) {
          this.routePop = true;
          this.routeDetail = routeItem;
        }
      }
      if (gtype === "Point" && feature.get("type") === "location") {
        ElMessage({
          message: "【仅用户在地图所选区域内生效】",
          type: "warning"
        });
      }
    },
    /**
     * 标准模版获取点位详情
     * @param {Object} feature 选中数据
     */
    standardDetail(currentInfo) {
      console.log("currentInfo", currentInfo);
      let formatinfo = {};
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.audio = formatinfo.audio.length > 0 ? formatinfo.audio.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      formatinfo.video = formatinfo.video.length > 0 ? formatinfo.video.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      formatinfo.audiodesc = formatinfo.audiodesc && formatinfo.audiodesc.length > 0 ? formatinfo.audiodesc.map(item => {
        item.title = item.name.replace(`.${item.suffix}`, "");
        this.$api.getUrlByObjectId(item.objectId).then(res => {
          item.url = res.http;
        });
        return item;
      }) : "";
      console.log(`formatinfo.video`, formatinfo.video);
      if (formatinfo["42"] === "弹窗") {
        this.pointdetail = formatinfo;
        this.pointdetail.formUserId = currentInfo.id;
        this.pointdetail.formId = currentInfo.formId;
        this.pointdetail.view = Number(this.pointdetail.view) + 1;
        console.log("弹窗", this.pointdetail);
        this.editViews(this.pointdetail);
        this.popshowflag = true;
      }
      if (formatinfo["42"] === "链接" && formatinfo["44"] !== "") {
        let url = formatinfo["44"];
        if (formatinfo["44"].includes("superMapv2")) {
          let cparams = formatinfo["44"].split("?")[1];
          url = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams;
        }
        window.open(url);
      }
    },
    /**
     * 非遗模版获取点位详情
     * @param {Object} feature 选中数据
     */
    culturalDetail(currentInfo, feature) {
      let formatinfo = {};
      let coordinate = feature.xy ? feature.xy : feature.get("xy");
      Object.keys(currentInfo.itemformdata).forEach(key => {
        formatinfo[key] = currentInfo.itemformdata[key];
      });
      formatinfo.id = currentInfo.id;
      formatinfo.coordinate = coordinate;
      formatinfo.gateway = formatinfo.gateway = formatinfo.detailUrl !== "" ? `${formatinfo.detailUrl}${formatinfo.detailUrl.includes("?") ? "&" : "?"}mapid=${formatinfo.number}` : "";
      formatinfo.pixelcoordinate = this.$refs.mapv2assembly.getmapPixelFromCoordinate(currentInfo);
      this.pointdetail = formatinfo;
      this.popshowflag = true;
      this.getCulturalperson(formatinfo);
      this.getCulturalpic(formatinfo);
      this.getCulturalvideo(formatinfo);
      // 客家(闽西)非遗博物馆 龙岩
      if (this.query.fid === "138053") {
        this.getSeminar(formatinfo);
        this.popmodeltype = 4; //先定制后删除
      }
      if ((this.popmodeltype === 1 || this.popmodeltype === 4) && !this.isMobileflag) {
        this.$nextTick(() => {
          this.$refs.mapv2assembly.addpopOverLay(coordinate);
        });
      }
    },
    /**
     * 点位获取对应非遗传承人数据
     * @param {Object} feature 选中数据
     */
    getCulturalperson(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "project_name",
            compt: "editinput",
            express: "===",
            val: formatinfo.title
          }]
        }]
      };
      this.culturalpersonform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpersonform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpersonform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpersonform.page === 1) that.mapculturalpersonList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpersonList = that.culturalpersonform.page === 1 ? res.dataList : that.mapculturalpersonList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpersonform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.person = that.mapculturalpersonList;
        }
      });
    },
    /**
     * 点位获取对应项目图片表单数据
     * @param {Object} feature 选中数据
     */
    getCulturalpic(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: this.query.fid === "138053" ? "number" : "19",
            compt: "editinput",
            express: "===",
            val: formatinfo.number
          }]
        }]
      };
      // 龙岩138053
      if (this.query.fid === "138053") {
        this.culturalpicform.formId = "1539909";
        this.culturalpicform.t = "28cfc16722e657e0a8544fcc4170635a1838e364615b9ea94f1161c5b1664675";
      }
      this.culturalpicform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalpicform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalpicform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalpicform.page === 1) that.mapculturalpicList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalpicList = that.culturalpicform.page === 1 ? res.dataList : that.mapculturalpicList.concat(res.dataList);
          if (res.totalPage > 1) that.culturalpicform.page++;
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.pictureList = that.mapculturalpicList;
        }
      });
    },
    /**
     * 点位获取对应项目视频表单数据
     * @param {Object} feature 选中数据
     */
    getCulturalvideo(formatinfo) {
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: this.query.fid === "138053" ? "number" : "1",
            compt: this.query.fid === "138053" ? "editinput" : "selectbox",
            express: "===",
            val: this.query.fid === "138053" ? formatinfo.number : [formatinfo.title]
          }]
        }]
      };
      if (this.query.fid === "138053") {
        this.culturalvideoform.formId = "1540105";
        this.culturalvideoform.t = "af229fb2c9b88028bfb98461282282f20b24954a46827574c4a07d6218162bb6";
      }
      this.culturalvideoform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.culturalvideoform.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalvideoform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.culturalvideoform.page === 1) that.mapculturalvideoList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.mapculturalvideoList = that.culturalvideoform.page === 1 ? res.dataList : that.mapculturalvideoList.concat(res.dataList);
          // if (res.totalPage > 1) that.culturalvideoform.page++
          // if (res.totalPage >= that.pointform.page) that.getpointData()
          that.pointdetail.videoList = that.mapculturalvideoList;
        }
      });
    },
    /**
     * 点位获取对应传习所表 【龙岩地图定制】 202406251652 看后期如何定制 url：seminar202406251701
     * @param {Object} feature 选中数据
     */
    getSeminar(formatinfo) {
      let seminar = {
        formId: "1575388",
        page: 1,
        limit: 100,
        searchStr: "",
        t: "4f4bf90d9e5aaf56878c6788d5471a5acb372f5a11d78917d362ce3fb72373ed"
      };
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "3",
            compt: "editinput",
            express: "===",
            val: formatinfo.number
          }]
        }]
      };
      seminar.searchStr = encodeURI(JSON.stringify(searchStr));
      seminar.deptId = this.query.fid;
      let that = this;
      this.$api.singleadvanceSearchv2(seminar).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.pointdetail.seminarList = res.dataList;
        }
      });
    },
    /**
     * 弹窗关闭事件
     */
    closeHandle() {
      this.popshowflag = false;
      this.pointdetail = {};
      if (!this.isMobileflag) document.querySelector(".map_content").style.zIndex = 2;
    },
    /**
     * 分类选择事件
     */
    typeselect(val) {
      console.log("city");
      this.rotateCloud();
      if (this.id === 1) {
        this.typeClick(val);
      } else {
        this.$emit("typeselect", val);
      }
    },
    /**
     * 分类数据格式化
     */
    typebtnFormat(val) {
      let typebtn = [...val];
      this.typebtn = [];
      typebtn.forEach(elem => {
        let item = {
          ...elem
        };
        if (item.imgList && item.imgList.length > 0) {
          item.backgroundImage = "url('" + getImg(item.imgList[0]) + "')";
          item.backgroundSize = "100% 100%";
          item.backgroundRepeat = "no-repeat";
        }
        item.textAlign = "center";
        delete item.imgList;
        let newitem = {};
        Object.keys(item).forEach(child => {
          if (this.isMobileflag) {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 2 / 37.5).toFixed(6))}rem` : item[child];
          } else {
            newitem[child] = /px$/.test(item[child]) ? `${parseFloat((parseInt(item[child]) / 1920 * 100).toFixed(6))}vw` : item[child];
          }
        });
        this.typebtn.push(newitem);
      });
    },
    removeAlliconsource() {
      this.$refs.mapv2assembly.removeAlliconsource();
    },
    saveDrawHandle() {
      this.$refs.mapv2assembly.saveDrawHandle();
    },
    updateMap() {
      this.$refs.mapv2assembly.updateMap();
    },
    removeDrawsource() {
      this.$refs.mapv2assembly.removeDrawsource();
    },
    removeRoutesource() {
      this.$refs.mapv2assembly.removeRoutesource();
    },
    isHasallarea(val) {
      let that = this;
      let mapform = {
        deptId: this.query.fid,
        formId: "177623",
        page: 1,
        limit: 100,
        searchStr: {
          model: 0,
          filters: [{
            model: 0,
            filters: [{
              alias: "ishaschild",
              compt: "radiobutton",
              express: "===",
              val: ["是"]
            }]
          }]
        }
      };
      mapform.searchStr = encodeURI(JSON.stringify(mapform.searchStr));
      this.$api.singleadvanceSearch(mapform).then(res => {
        if (res.totalRow > 0) {
          this.showgolist = val.ishaschild === "是" ? false : true;
          if (this.showgolist) this.showgolistId = res.dataList[0].id;
        }
      });
    },
    golist() {
      let cquery = location.hash.split("?")[1];
      let cparams = cquery.split("&");
      cparams = cparams.map(item => {
        let itemarr = item.split("=");
        if (itemarr[0] === "formUserId") {
          itemarr[1] = this.showgolistId;
          item = itemarr.join("=");
        }
        return item;
      });
      window.location.href = location.protocol + "//" + location.host + location.pathname + "?page=superMapv2?" + cparams.join("&");
    },
    /**
     * 获取非遗项目表单结构数据
     */
    getCulturalFormStruct() {
      let params = {
        deptId: this.query.fid,
        formId: "cultural_heritage_project"
      };
      this.$api.formStruct(params).then(res => {
        this.cstructList = JSON.parse(JSON.stringify(res));
        this.cpList = getformatstruct(res, this.cform, this.cformlabel, this.cformfield, this.cformoption);
        this.defaultcform = Object.assign({}, this.cform);
      });
    },
    setComonStyle() {
      document.querySelector("html").style.fontSize = `${window.screen.width / 10}px`;
    },
    /**
     * 获取地图设置行
     */
    getMapData(val) {
      let that = this;
      let formUserId = val ? cdata.hbuFormUserId[val] : this.query.formUserId;

      // let formUserId = this.query.formUserId;
      // let formUserId = 2810411061;
      // this.query.fid

      this.$api.singleformUserId(this.query.fid, "177623", formUserId).then(res => {
        if (res.formUserList.length > 0) {
          that.cformUser = res.formUserList[0];
          let formatData = {};
          res.formUserList[0].formData.forEach(item => {
            formatData[item.alias] = getformitemsdata(item);
          });
          that.formatData = formatData;
          console.log("that.formatData", that.formatData);
          document.title = formatData.toptitle;
          // 处理地图view相关字段
          that.getFormStruct(val);
        }
      });
    },
    /**
     * 获取地图配置表单结构
     */
    getFormStruct(val) {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.sList = getformatstruct(res, this.form, this.formlabel, this.formfield, this.formoption);
        // 渲染地图
        this.mapview = this.mapv2info.view;
        // 渲染图片
        this.editlogic(this.formatData);
        // 右侧选择项
        // if(!val){
        //   this.gettypeList();
        // }
        this.gettypeList(val);
      });
    },
    /**
     * 配置页编辑逻辑处理
     */
    editlogic(data) {
      let that = this;
      this.mapLayers.tiles = true;
      this.mapLayers.json = true;
      this.mapLayers.static = false;
      Object.keys(data).forEach(item => {
        this.form[item] = data[item];
      });
      this.jsonOption = {
        ...JSON.parse(this.form.jsontxt.replace(/(<\/?p.*?>)/gi, ""))
      };
      if (this.jsonOption.screen && Object.keys(this.jsonOption.screen).length > 0) {
        let screenData = this.isMobileflag ? this.jsonOption.screen.app : this.jsonOption.screen.pc;
        Object.keys(screenData).forEach(item => {
          this.jsonOption[item] = screenData[item];
        });
      }
      console.log(`this.jsonOption`, this.jsonOption);
      this.mapviewhandle(this.jsonOption.view);
      this.form.showtype = this.jsonOption.style.showtype;
      this.form.showlistflag = this.jsonOption.style.showlistflag;
      this.form.scale = this.jsonOption.view.scale;
      this.form.rotate = this.jsonOption.view.rotate;
      this.form.typeall = this.jsonOption.style.typeall !== undefined ? this.jsonOption.style.typeall : true;
      this.form.typeallname = this.jsonOption.style.typeallname ? this.jsonOption.style.typeallname : "全部";
      this.form.routelinetype = this.jsonOption.style.routelinetype ? this.jsonOption.style.routelinetype : 1;
      if (this.form.fillcolor) this.form.fillcolor = [...JSON.parse(this.form.fillcolor.replace(/(<\/?p.*?>)/gi, ""))];
      this.form.fillimageindex = this.form.fillimageindex && this.form.fillimageindex !== "" ? Number(this.form.fillimageindex) : this.form.fillimageindex === "" ? this.form.fillimageindex : 1;
      if (this.isMobileflag) {
        this.mapLayers.staticimage = this.form.app_static_img && this.form.app_static_img.length > 0 ? getImg(this.form.app_static_img[0]) : getImg(this.form.static_img[0]);
      } else {
        if (this.form.static_img && this.form.static_img.length > 0) this.mapLayers.staticimage = getImg(this.form.static_img[0]);
      }
      if (this.form.mapmodetype === this.formoption.mapmodetype[1].title && this.form.filltype === this.formoption.filltype[1].title && this.form.fillclipimage !== "") {
        this.form.fillclipimage = this.form.fillclipimage.replace(/(<\/?p.*?>)/gi, "").match(/src="([^"]*)"/i)[1];
        this.mapLayers.staticimage = this.form.fillclipimage;
      }
      if (this.form.background_img && this.form.background_img.length > 0) this.mapLayers.tiles = false;
      if (this.mapLayers.staticimage !== "") this.mapLayers.static = true;
      this.SET_MAPFORM(this.form);
      this.SET_MAPVIEW(this.jsonOption.view);
      this.SET_MAPSENIOR(this.jsonOption.senior);
      this.SET_MAPSTYLEITEM({
        showtype: this.jsonOption.style.showtype
      });
      this.SET_MAPSTYLEITEM({
        showlistflag: this.jsonOption.style.showlistflag
      });
      this.SET_MAPSTYLEITEM({
        typeall: this.form.typeall
      });
      this.SET_MAPSTYLEITEM({
        typeallname: this.form.typeallname
      });
      this.SET_MAPSTYLEITEM({
        routelinetype: this.form.routelinetype
      });
      this.mapview = this.jsonOption.view;
      this.mapstyle = this.jsonOption.style;
      this.mapstyle.typeall = this.form.typeall;
      this.mapstyle.typeallname = this.form.typeallname;
      this.mapsenior = this.jsonOption.senior;

      // 若开启浏览量 增加浏览量
      if (this.mapsenior.visit) this.getVisits();

      // 判断当前地图模版 score  0标准模版  1非遗模版
      this.formoption.mapTemplate.forEach(elem => {
        if (this.formatData.mapTemplate === elem.title) {
          this.cTemplateScore = elem.score;
          this.SET_MAPFORMITEM({
            cTemplateScore: elem.score
          });
        }
      });
      this.SET_MAPDRAWLAYER(this.jsonOption.drawlayer);
      this.mapLayers.drawelement = this.jsonOption.drawlayer;
      if (this.form.componentjson !== undefined) {
        let comptdata = this.form.componentjson.replace(/(<\/?p.*?>)/gi, "");
        if (comptdata !== "") {
          let data = JSON.parse(comptdata);
          this.form.editorList = this.isMobileflag ? data.appList : data.List;
          this.form.pcwidth = data.pcwidth;
          this.form.pcheight = data.pcheight;
        }
      }
      this.mapformHandle(this.form);
      this.$nextTick(() => {
        // console.log(`this.jsonOption.style`, this.jsonOption.style)
        this.styleHandle(this.jsonOption.style);
        this.typebtnFormat(this.jsonOption.style.typebtn);
        this.popcolorFormat(this.jsonOption.style.popcolor);
      });
      // 是否含有乡镇街道
      if (Object.prototype.toString.call(this.jsonOption.geojson) === "[object Array]" && this.jsonOption.geojson[0].code) {
        this.mapstreetcode = this.jsonOption.geojson.map(item => {
          return item.code;
        });
      } else if (Object.prototype.toString.call(this.jsonOption.geojson) === "[object Object]" && this.jsonOption.geojson.code) {
        this.mapstreetcode = [this.jsonOption.geojson.code];
      }
      let adcode = this.jsonOption.view.adcode;
      if (this.mapstreetcode.length > 0) {
        axios.get(`${process.env.NODE_ENV === "development" ? "/fileapi" : location.origin}/frontendTest1/openlayers/data/${adcode}.json`).then(res => {
          if (res.status === 200) {
            let jsondata = res.data;
            let filterJson = [];
            that.mapstreetcode.forEach(street => {
              jsondata.features.forEach(feature => {
                if (Number(feature.properties.code) === Number(street)) filterJson.push(feature);
              });
            });
            jsondata.features = filterJson;
            that.mapLayers.geojson = jsondata;
            that.loadingmap = true;
          }
        }).catch(error => {});
        return;
      }
      // 自定义json数据
      if (this.jsonOption.view.adcode === "region") {
        let datacoord = this.jsonOption.geojson.features[0].geometry.coordinates[0];
        let changedata = [];
        datacoord.forEach(elem => {
          changedata.push(transform(elem, "EPSG:4326", "EPSG:3857"));
        });
        this.jsonOption.geojson.features[0].geometry.coordinates[0] = changedata;
        this.mapLayers.geojson = {
          type: "FeatureCollection",
          features: this.jsonOption.geojson.features
        };
      }
      console.log("this.mapLayers", this.mapLayers);
      this.loadingmap = true;
    },
    mapviewhandle(view) {
      let center = view.center;
      this.form.centerX = center[0];
      this.form.centerY = center[1];
      this.form.minZoom = view.minZoom;
      this.form.maxZoom = view.maxZoom;
      this.form.zoom = view.zoom;
      this.form.static_map_min_level = view.minZoom;
      this.form.static_map_max_level = view.maxZoom;
      this.form.current_level = view.zoom;
      this.form.map_center = center.join(",");
      this.form.transform_extent = view.extent.join(",");
    },
    /**
     * 获取分类列表数据
     */
    gettypeList(val) {
      console.log("gettypeList", val);
      let that = this;
      this.typeform.deptId = this.query.fid;
      this.$api.singleadvanceSearch(this.typeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          this.typeList = [];
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          this.typeList = res.dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          console.log("this.mapstyle.typeall", this.mapstyle.typeall);
          console.log("this.typeList[0].itemformdata.title", this.typeList[0].itemformdata.title);
          if (!this.mapstyle.typeall) {
            this.searchStr.filters.push({
              model: 0,
              filters: [{
                alias: "map_type2",
                compt: "editinput",
                express: "===",
                val: this.typeList[0].itemformdata.title
              }]
            });
          }
          // console.log(`typeList`, this.typeList)
        }
        console.log("this.jsonOption.geojson.name", this.jsonOption.geojson.name);
        // 处理地点管理表 请求参数
        this.pointform.deptId = this.query.fid;
        // console.log('this.formatData.title',this.formatData.title)
        // this.searchStr.filters[0].filters[0].val = this.formatData.title;
        if (this.jsonOption.geojson.name && !val) {
          this.searchStr.filters[0].filters[0].val = this.jsonOption.geojson.name + "红色文化数字地图";
          // this.searchStr.filters[2] = {
          //   model: 0,
          //   filters: [
          //     {
          //       alias: "map_type2",
          //       compt: "editinput",
          //       express: "===",
          //       val: this.jsonOption.geojson.name,
          //     },
          //   ],
          // };
        } else if (val) {
          this.searchStr.filters[0].filters[0].val = val + "红色文化数字地图";
          // this.searchStr.filters[2] = {
          //   model: 0,
          //   filters: [
          //     {
          //       alias: "map_type2",
          //       compt: "editinput",
          //       express: "===",
          //       val: val,
          //     },
          //   ],
          // };
        } else if (!this.jsonOption.geojson.name && !this.jsonOption.geojson.name) {
          this.searchStr.filters[0].filters[0].val = "河北省红色文化数字地图";
        }

        // this.searchStr.filters.push({
        //       model: 0,
        //       filters: [
        //         {
        //           alias: "map_type2",
        //           compt: "editinput",
        //           express: "===",
        //           val: this.jsonOption.geojson.name,
        //         },
        //       ],
        //     });
        // if (val != "河北省") {
        // this.searchStr.filters[2] = {
        //   model: 0,
        //   filters: [
        //     {
        //       alias: "map_type2",
        //       compt: "editinput",
        //       express: "===",
        //       val: this.jsonOption.geojson.name,
        //     },
        //   ],
        // };
        // }

        let zoom = this.mapview.zoom;
        let minZoom = this.mapview.minZoom;
        if (this.isMobileflag) {
          let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
          console.log(`Difference`, Difference);
          zoom += Difference;
        }
        let orData = [];
        for (let i = minZoom; i <= zoom; i++) {
          orData.push({
            alias: "map_level",
            compt: "editinput",
            express: "===",
            val: i
          });
        }
        this.searchStr.filters.forEach(item => {
          if (item.model === 1) item.filters = orData;
        });
        console.log("this.searchStr", this.searchStr);
        this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
        console.log(2);
        this.getpointData();
        // 处理非遗项目表单数据
        if (this.cTemplateScore === 1) {
          let searchStr = {
            model: 0,
            filters: [{
              model: 0,
              filters: [{
                alias: "correlation_map",
                compt: "selectbox",
                express: "===",
                val: ["是"]
              }]
            }]
          };
          this.culturalform.searchStr = encodeURI(JSON.stringify(searchStr));
          this.culturalform.deptId = this.query.fid;
          this.getIntangibleCulturalHeritageData();
          if (this.isMobileflag) this.removeDrawsource();
        }
      });
    },
    /**
     * 获取地点管理表数据
     */
    getpointData(val) {
      console.log("val", val);
      let that = this;
      // if (val) {
      //   let searchStr = {
      //     model: 0,
      //     filters: [
      //       {
      //         model: 0,
      //         filters: [
      //           {
      //             alias: "40",
      //             compt: "editinput",
      //             express: "===",
      //             val: "河北大学红色数字地图",
      //           },
      //           // {
      //           //   alias: "map_type",
      //           //   compt: "selectbox",
      //           //   express: "===",
      //           //   val: [`[["${val}"]]`],
      //           // },
      //            {
      //             alias: "map_type2",
      //             compt: "editinput",
      //             express: "===",
      //             val: val,
      //           },

      //         ],
      //       },
      //     ],
      //   };
      console.log(" this.pointform.searchStr ", this.searchStr);
      //   this.pointform.searchStr = encodeURI(JSON.stringify(searchStr));
      // }
      // console.log("河北大学红色数字地图", this.pointform);
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        console.log("河北大学红色数字地图res", res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.defaultpointList = [];
          let dataList = that.formdataformat(res);

          // if(val){
          //   dataList=dataList.filter(e=>{
          //     e.formIdValueData
          //   })
          // }
          that.defaultpointList = that.pointform.page === 1 ? dataList : that.defaultpointList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage === 1 || res.totalPage > 1 && res.totalPage + 1 === that.pointform.page) that.pointList = that.defaultpointList;
          if ((res.totalPage === 1 || res.totalPage === that.pointform.page) && val === undefined) that.getroutetypeData();
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) {
            console.log(3);
            that.getpointData(val);
          }
        }
      });
    },
    // 新增，根据不同城市，来切换
    // getpointDataEachCity(val) {
    //   let that = this;
    //   let searchStr = {
    //     model: 0,
    //     filters: [
    //       {
    //         model: 0,
    //         filters: [
    //           {
    //             alias: "40",
    //             compt: "editinput",
    //             express: "===",
    //             val: "保定市红色数字地图",
    //           },
    //         ],
    //       },
    //       {
    //         model: 1,
    //         filters: [
    //           {
    //             alias: "map_level",
    //             compt: "editinput",
    //             express: "===",
    //             val: 6,
    //           },
    //           {
    //             alias: "map_level",
    //             compt: "editinput",
    //             express: "===",
    //             val: 7,
    //           },
    //         ],
    //       },
    //     ],
    //   };
    //   this.pointform.searchStr = encodeURI(JSON.stringify(searchStr));
    //   this.$api.singleadvanceSearch(this.pointform).then((res) => {
    //     // console.log(res);
    //     if (res.totalRow > 0) {
    //       if (that.pointform.page === 1) that.defaultpointList = [];
    //       let dataList = that.formdataformat(res);
    //       that.defaultpointList =
    //         that.pointform.page === 1 ? dataList : that.defaultpointList.concat(dataList);
    //       if (res.totalPage > 1) that.pointform.page++;
    //       if (
    //         res.totalPage === 1 ||
    //         (res.totalPage > 1 && res.totalPage + 1 === that.pointform.page)
    //       )
    //         that.pointList = that.defaultpointList;
    //       if (
    //         (res.totalPage === 1 || res.totalPage === that.pointform.page) &&
    //         val === undefined
    //       )
    //         that.getroutetypeData();
    //       if (res.totalPage > 1 && res.totalPage >= that.pointform.page)
    //         that.getpointDataEachCity();
    //     }
    //     console.log(" that.pointList = that.defaultpointList;", that.pointList);
    //   });
    // },
    /**
     * 点击类型操作
     * @param {Object} data 选中数据及索引 index item
     */
    typeClick(data) {
      this.loadingmap = false;
      this.cType = data;
      this.popshowflag = false;
      this.removeAlliconsource();
      // let dindex = data.index;
      // let val = dindex === 0 ? "" : !data.child ? data.item.itemformdata : data.child;
      // let typesearchflag = false;
      // if (dindex === 0) {
      //   this.searchStr.filters.forEach((item, index) => {
      //     if (item.filters.length > 0 && item.filters[0].alias === "map_type2")
      //       this.searchStr.filters.splice(index, 1);
      //   });
      // } else {
      //   this.searchStr.filters.forEach((item) => {
      //     if (item.filters.length > 0 && item.filters[0].alias === "map_type2") {
      //       item.filters[0].val = val.title;
      //       typesearchflag = true;
      //     }
      //   });
      //   if (!typesearchflag) {
      //     this.searchStr.filters.push({
      //       model: 0,
      //       filters: [
      //         {
      //           alias: "map_type2",
      //           compt: "editinput",
      //           express: "like",
      //           val: val.title,
      //         },
      //       ],
      //     });
      //   }
      // }
      let zoom = this.mapview.zoom;
      let minZoom = this.mapview.minZoom;
      if (this.isMobileflag) {
        let Difference = Math.round(this.jsonOption.screen.pc.view.zoom) - Math.round(this.jsonOption.screen.app.view.zoom);
        console.log(`Difference`, Difference);
        zoom += Difference;
      }
      let orData = [];
      for (let i = minZoom; i <= zoom; i++) {
        orData.push({
          alias: "map_level",
          compt: "editinput",
          express: "===",
          val: i
        });
      }
      this.searchStr.filters.forEach(item => {
        if (item.filters.length > 0 && item.filters[0].alias === "40" && item.filters[0].val === "") item.filters[0].val = this.form.title;
        if (item.model === 1) item.filters = orData;
      });
      if (this.pointform.deptId === undefined) this.pointform.deptId = this.query.fid;
      this.pointform.searchStr = encodeURI(JSON.stringify(this.searchStr));
      this.pointform.page = 1;
      this.pointList = [];
      let city = data && data.item && data.item.itemformdata && data.item.itemformdata.title ? data.item.itemformdata.title : "";
      console.log("dada", data);
      if (data.index == 0) {
        city = "河北省";
      }
      if (!city || city == "河北省") {
        console.log(4);
        this.getpointData();
      }
      // 点击非全部类型 隐藏路线列表
      this.$refs.routelist.routebtnHide();
      this.$refs.mapv2assembly.removeRoutesource();
      this.getMapData(city);
      // console.log(5);
      // this.getpointData(city);
    },
    /**
     * 获取非遗项目表单数据
     */
    getIntangibleCulturalHeritageData() {
      let that = this;
      this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
        if (res.totalRow > 0) {
          if (that.culturalform.page === 1) that.mapdefaultculturalList = [];
          that.culturaldataformat(res);
          if (res.totalPage > 1) that.culturalform.page++;
          if (res.totalPage > 1 && that.culturalform.page === res.totalPage + 1 || res.totalPage === 1) {
            if (that.query.fid === "138053") {
              // 龙岩非遗 过滤【表单审核状态通过】数据
              that.mapculturalList = that.mapdefaultculturalList.filter(item => {
                return item.aprvStatus === 1;
              });
            } else {
              that.mapculturalList = that.mapdefaultculturalList;
            }
          }
          if (res.totalPage > 1 && res.totalPage >= that.culturalform.page) that.getIntangibleCulturalHeritageData();
        }
      });
    },
    culturaldataformat(res) {
      res.dataList.forEach((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        if (this.typeList.length > 0) {
          let type = this.typeList.find(elem => {
            return elem.itemformdata.title === itemformat.level;
          });
          if (type && type.itemformdata.icon.length > 0) itemformat.icon = getImg(type.itemformdata.icon[0]);
        }
        item.itemformdata = itemformat;
      });
      this.mapdefaultculturalList = this.culturalform.page === 1 ? res.dataList : this.mapdefaultculturalList.concat(res.dataList);
    },
    pointlistClick(item) {
      let components = this.$refs.pointlist.$options.components;
      Object.keys(components).forEach(key => {
        if (this.mapstyle.listStyleIndex === Number(key.charAt(key.length - 1))) components[key].methods.listDown();
      });
      this.pointdetail = {};
      this.popshowflag = false;
      let citem = item.itemformdata;
      if (this.cTemplateScore === 0) this.standardDetail(item);
      if (this.cTemplateScore === 1 && citem.correlation_address.length > 0) {
        let gd = bd_decrypt(Number(citem.correlation_address[0].lng), Number(citem.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        this.culturalDetail(item, {
          xy: [x, y]
        });
      }
    },
    listUp() {
      this.pointdetail = {};
      this.popshowflag = false;
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    getroutetypeData() {
      let that = this;
      this.rtypeform.deptId = this.query.fid;
      let searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "mapbelongId",
            compt: "editinput",
            express: "===",
            val: this.formatData.onlyid
          }]
        }]
      };
      this.rtypeform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.rtypeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.rtypeform.page === 1) that.rtypeList = [];
          let dataList = that.formdataformat(res);
          let sortdataList = dataList.sort((a, b) => Number(a.itemformdata.sortId) - Number(b.itemformdata.sortId));
          that.rtypeList = that.routeform.page === 1 ? sortdataList : that.rtypeList.concat(sortdataList);
          if (res.totalPage > 1) that.rtypeform.page++;
          if (res.totalPage === 1 || res.totalPage === that.rtypeform.page) that.getrouteData();
          if (res.totalPage > 1 && res.totalPage >= that.rtypeform.page) that.getroutetypeData();
        }
      });
    },
    /**
     * 获取路线管理表表单数据
     */
    getrouteData() {
      let that = this;
      this.routeform.deptId = this.query.fid;
      this.$api.singleadvanceSearchv2(this.routeform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.routeform.page === 1) that.maprouteList = [];
          let dataList = that.formdataformat(res);
          that.maprouteList = that.routeform.page === 1 ? dataList : that.maprouteList.concat(dataList);
          if (res.totalPage > 1) that.routeform.page++;
          // if (res.totalPage === 1 || res.totalPage === that.routeform.page) {
          //     if (that.cType === '') that.routeHandle(that.maprouteList)
          // }
          if (res.totalPage > 1 && res.totalPage >= that.routeform.page) that.getrouteData();
        }
      });
    },
    routeChange(val) {
      console.log(`routeChange`, val);
      if (val.length === 0) {
        this.typeClick(this.cType === "" ? {
          index: 0,
          item: ""
        } : this.cType);
        return;
      }
      this.mapLayers.route = true;
      this.getsingleroute(val);
    },
    getsingleroute(val) {
      let routePoint = [];
      val.forEach(elem => {
        this.routejson = {
          ...JSON.parse(elem.itemformdata.jsontxt.replace(/(<\/?p.*?>)/gi, ""))
        };
        this.routejson.routedata.forEach(item => {
          let route = this.pointList.find(point => {
            return point.id === item.id;
          });
          if (route !== undefined) routePoint.push(route);
        });
      });
      this.routePoint = routePoint;
      this.setRoutePoint(routePoint);
      this.routeHandle(val);
    },
    routeHandle(val) {
      this.routeAllLen = val.length;
      this.routeAllSource = [];
      let routes = [];
      for (let i = 0; i < this.routePoint.length - 1; i++) {
        let start = this.routePoint[i].itemformdata.map_coordinates.split(",").map(parseFloat);
        let end = this.routePoint[i + 1].itemformdata.map_coordinates.split(",").map(parseFloat);
        routes.push([start, end]);
      }

      // 若存在curvedata参数 代表曲线
      if (this.routejson.curvedata !== undefined && this.form.routelinetype === 3 && this.routejson.curvedata.length > 0) {
        routes.forEach((item, index) => {
          let curveitem = this.routejson.curvedata[index];
          if (curveitem !== null) curveitem.forEach((point, pIndex) => {
            item.splice(pIndex + 1, 0, [point[0], point[1]]);
          });
        });
      }
      if (routes.length === 0) {
        this.routeAllSource = [];
        this.SET_MAPROUTESOURCE([]);
        return;
      }
      if (this.form.routelinetype === 1) {
        this.routeAllSource = [];
        let routeItemAllpath = [];
        this.routeDriving(routes, 0, routeItemAllpath, this.routejson.style, val[0].id);
      }
      if (this.form.routelinetype !== 1) {
        let paths = routes.map(elem => {
          return elem.map(item => {
            return transform([item[0], item[1]], "EPSG:4326", "EPSG:3857");
          });
        });
        console.log(`paths`, paths);
        this.SET_MAPROUTESOURCE([{
          path: paths,
          style: this.routejson.style,
          routelinetype: this.form.routelinetype,
          isCurve: false
        }]);
      }
    },
    routeDriving(routes, index, routeItemAllpath, linestyle, id) {
      let route = routes[index];
      if (route === undefined) return;
      let start = new window.BMapGL.Point(route[0][0], route[0][1]);
      let end = new window.BMapGL.Point(route[1][0], route[1][1]);
      let driving = new window.BMapGL.DrivingRoute(this.mapcontainer);
      driving.search(start, end);
      driving.setSearchCompleteCallback(() => {
        let routepath = [];
        if (driving.getResults() === undefined) return;
        let pots = driving.getResults().getPlan(0).getRoute(0).getPath();
        pots.forEach((pot, idx) => {
          let bdTogd = bd_decrypt(pot.lng, pot.lat);
          routepath.push(transform([bdTogd.lng, bdTogd.lat], "EPSG:4326", "EPSG:3857"));
        });
        routeItemAllpath.push(routepath);
        if (routes.length === 1 || index === routes.length - 1) {
          this.routeAllSource.push({
            path: routeItemAllpath,
            style: linestyle,
            id: id
          });
          this.SET_MAPROUTESOURCE(this.routeAllSource);
          // if (this.routeAllSource.length === this.routeAllLen) this.SET_MAPROUTESOURCE(this.routeAllSource)
        }
        if (routes.length > 1 && index <= routes.length - 1) this.routeDriving(routes, index + 1, routeItemAllpath, linestyle, id);
      });
    },
    routeshow(val) {
      this.mapLayers.route = val;
    },
    /**
     * 增加浏览量
     */
    getVisits() {
      let that = this;
      let nowTime = new Date();
      let date = formateDate(nowTime, "yyyy-MM-dd");
      const searchStr = {
        model: 0,
        filters: [{
          model: 0,
          filters: [{
            alias: "id",
            compt: "editinput",
            express: "===",
            val: this.formatData.onlyid
          }, {
            alias: "date",
            compt: "editinput",
            express: "===",
            val: date
          }]
        }]
      };
      this.visitform.deptId = this.query.fid;
      this.visitform.searchStr = encodeURI(JSON.stringify(searchStr));
      this.$api.singleadvanceSearchv2(this.visitform).then(res => {
        res.totalRow > 0 ? that.editVisit(res, nowTime) : that.addVisit(nowTime, date);
      });
    },
    addVisit(nowTime, date) {
      let dataList = [];
      dataList.push({
        alias: "onlyid",
        compt: "autonumber",
        values: [{
          val: ""
        }]
      });
      dataList.push({
        alias: "title",
        compt: "selectbox",
        values: [{
          val: this.formatData.title
        }]
      });
      dataList.push({
        alias: "id",
        compt: "editinput",
        values: [{
          val: this.formatData.onlyid
        }]
      });
      dataList.push({
        alias: "date",
        compt: "editinput",
        values: [{
          val: date
        }]
      });
      dataList.push({
        alias: "timestamp",
        compt: "editinput",
        values: [{
          val: nowTime.getTime()
        }]
      });
      dataList.push({
        alias: "visits",
        compt: "numberinput",
        values: [{
          val: 1
        }]
      });
      console.log(`dataList`, dataList);
      let formData = {
        deptId: this.query.fid,
        formId: this.visitform.formId,
        uid: this.query.uid
      };
      this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {});
    },
    editVisit(res, nowTime) {
      let resList = this.formdataformat(res);
      let dataList = [];
      dataList.push({
        alias: "onlyid",
        compt: "autonumber",
        values: [{
          val: resList[0].itemformdata.onlyid
        }]
      });
      dataList.push({
        alias: "title",
        compt: "selectbox",
        values: [{
          val: this.formatData.title
        }]
      });
      dataList.push({
        alias: "visits",
        compt: "numberinput",
        values: [{
          val: Number(resList[0].itemformdata.visits) + 1
        }]
      });
      dataList.push({
        alias: "timestamp",
        compt: "editinput",
        values: [{
          val: nowTime.getTime()
        }]
      });
      this.$api.editForm(this.query.fid, resList[0].id, encodeURI(JSON.stringify(dataList)), resList[0].formId).then(res => {});
    },
    editViews(res) {
      let dataList = [];
      dataList.push({
        alias: "onlyid",
        compt: "autonumber",
        values: [{
          val: res.onlyid
        }]
      });
      dataList.push({
        alias: "title",
        compt: "editinput",
        values: [{
          val: res.title
        }]
      });
      dataList.push({
        alias: "view",
        compt: "numberinput",
        values: [{
          val: (res.view ? Number(res.view) : 0) + 1
        }]
      });
      this.$api.editForm(this.query.fid, res.formUserId, encodeURI(JSON.stringify(dataList)), res.formId).then(res => {
        console.log("editViews", res);
      });
    },
    setRoutePoint(val) {
      this.$refs.mapv2assembly.removeAlliconsource();
      this.$refs.mapv2assembly.removeRoutesource();
      this.$refs.mapv2assembly.createPoint(val);
      // this.$refs.mapv2assembly.stopMove(true)
    },
    /**
     * 添加特效
     */
    effectAnimate() {
      this.$nextTick(() => {
        document.querySelector(".yunbox").classList.remove("hidden");
        const yunl = document.querySelector(".yunl");
        const yunr = document.querySelector(".yunr");
        let keyframesl = [{
          left: "-100%"
        }];
        let keyframesr = [{
          right: "-100%"
        }];
        let options = {
          duration: 4000,
          iterations: 1,
          fill: "forwards"
        };
        yunl.animate(keyframesl, options).onfinish = () => {
          const yunbox = document.querySelector(".yunbox");
          if (yunbox !== null) yunbox.classList.add("hidden");
        };
        yunr.animate(keyframesr, options).onfinish = () => {};
      });
    },
    /**
     * 背景音乐操作事件
     */
    bgaudioHandle() {
      this.bgaudioflag = !this.bgaudioflag;
      if (this.form.bgaudioicon) {
        this.mapelem.bgaudio = !this.bgaudioflag ? this.form.bgaudioicon[1] ? getImg(this.form.bgaudioicon[1]) : "" : this.form.bgaudioicon[0] ? getImg(this.form.bgaudioicon[0]) : "";
      }
      if (this.form.bgaudiofile && this.form.bgaudiofile[0]) {
        !this.bgaudioflag ? this.$refs.bgaudio.pause() : this.$refs.bgaudio.play();
      }
    },
    /**
     * 获取背景音乐文件
     */
    getBgaudiofile(val) {
      this.$api.getUrlByObjectId(val.objectid || val.objectId).then(res => {
        this.bgaudio = res.http;
      });
    },
    domChange(item) {
      /* 展示页不需要编辑dom样式 */
      if (this.id === 1) {
        console.log(item);
        if (Object.keys(item.data).length === 0) return;
        if (item.data.url !== "") {
          const openUrl = item.data.url.replace(/；/g, "&");
          item.data.way ? window.open(openUrl) : window.location.href = openUrl;
        }
        return;
      }
      console.log(item);
      this.$emit("domclick", item);
    },
    getdomStyle(val) {
      let data = {
        ...val
      };
      const bodywidth = this.form.pcwidth;
      const bodyheight = this.form.pcheight;
      if (data.x <= bodywidth / 2) {
        data.left = Math.round(data.x) + "px";
      } else {
        data.right = Math.abs(bodywidth - Math.round(data.x) - data.width) + "px";
      }
      if (data.y <= bodyheight / 2) {
        data.top = Math.round(data.y) + "px";
      } else {
        data.bottom = Math.abs(bodyheight - Math.round(data.y) - data.height) + "px";
      }
      data.width = Math.round(data.width * (data.scaleX ? data.scaleX : 1)) + "px";
      data.height = Math.round(data.height * (data.scaleY ? data.scaleY : 1)) + "px";
      return data;
    },
    resetAllData() {
      // 创建初始状态的深层副本
      const initialState = JSON.parse(JSON.stringify(this.$options.data()));

      // 排除不需要重置的属性（如果有）
      // 例如，某些属性需要保留当前值，可以在这里排除它们
      // const excludeKeys = ['persistentProperty'];

      // 遍历初始状态的所有属性并重置当前数据
      for (const key in initialState) {
        // if (excludeKeys.includes(key)) continue;
        this[key] = initialState[key];
      }
    }
  }
};